import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService, LangChangeEvent, TranslationChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthenService } from '../services/authen.service';
import { SidebarService } from '../sidebar/sidebar.service';
import { NotifyService } from '../services/notify.service';

@Component({
    selector: 'menu-bar',
    templateUrl: './menu-bar.html',
    styleUrls: ['./menu-bar.css']
})
export class MenuBarComponent implements OnInit, OnDestroy {
    @ViewChild('dlgChangePwd') dlgChangePwd: any;
    subscLang: Subscription = null;
    classEN: string = 'selected-circle';
    classVN: string = '';

    constructor(public auth: AuthenService, public sidebar: SidebarService, private translate: TranslateService,
        private notify: NotifyService) {
    }

    ngOnInit() {
        this.subscLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            //this.notify.changeLang();

            setTimeout(() => {
                this.notify.changeLang();
            }, 100);
        });
    }

    ngOnDestroy() {
        //this.translate.onLangChange.unsubscribe();
        this.subscLang.unsubscribe();
    }

    onToggle() {
        this.sidebar.invertSidebarState();
    }

    onLangEN() {
        this.translate.use('en');
        this.classEN = 'selected-circle';
        this.classVN = '';
        //this.notify.changeLang();
    }

    onLangVN() {
        this.translate.use('vn');
        this.classEN = '';
        this.classVN = 'selected-circle';
        //this.notify.changeLang();
    }

    logOut() {
        this.auth.logout();
    }

    getSideBarState() {
        return this.sidebar.getSidebarState();
    }

    onChangePwd() {
        this.dlgChangePwd.show();
    }


    isToggled() {
        return this.sidebar.getSidebarState();
    }

}
